export const hoverEnter = (e: React.DragEvent<HTMLElement>) => {
  e.currentTarget.classList.add('hover');
};

export const hoverLeave = (e: React.DragEvent<HTMLElement>) => {
  e.currentTarget.classList.remove('hover');
};

export const dragEvent = (e: React.DragEvent<HTMLDivElement>, opportunity) => {
  if (e.dataTransfer && e.currentTarget) {
    e.dataTransfer.dropEffect = 'copy';
    if (e.currentTarget instanceof HTMLElement) {
      e.dataTransfer.setData('text/plain', opportunity.id);
    }
  }
};

export const handleSelectedServicesChange = (
  serviceId: string,
  checked: boolean,
  selectedServiceIds: string[],
): string[] => {
  if (checked) {
    if (!selectedServiceIds.includes(serviceId)) {
      return [...selectedServiceIds, serviceId];
    }
  } else {
    return selectedServiceIds.filter((id) => id !== serviceId);
  }
  return selectedServiceIds;
};
